import {Component, Input, OnInit} from '@angular/core';
import {RealmService} from '../Services/Realm/realm.service';
import {ApiService} from '../Services/Api/api.service';
import {environment} from '../../environments/environment';
import {NavigationStart, Router} from '@angular/router';
import { Location } from '@angular/common';
import {SessionService} from '../Services/Session/session-service.service';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.css']
})
export class CheckoutComponent implements OnInit {
  quequePosition = 0;
  quequeTime = '';
  quequeVariable = '';
  copaymentInfo = [];
  typeSelectedProvider = '';
  copayment = false;
  env = environment;
  provider: any;
  dialogCreditCard = false;
  paymentSuccess = false;
  isWaiting = false;
  selectedIdProvider = '';
  constructor(private realm: RealmService, private apiService: ApiService, private router: Router, private session: SessionService, private location: Location) { }

  ngOnInit(): void {
    console.log(this.session.getParam('selectedProvider'));
    console.log(JSON.parse(this.session.getParam('showSteps')));
    try {
      this.env.selectedProvider = JSON.parse(this.session.getParam('selectedProvider'));
      this.env.showSteps = JSON.parse(this.session.getParam('showSteps'));
      this.env.showSteps = true;
      this.env.activeIndex = 0;
    } catch (e) {
      this.env.showSteps = false;
      this.router.navigate(['home/providers']);
    }
    this.provider = JSON.parse(this.session.getParam('selectedProvider'));
    console.log(this.env.selectedProvider);
    console.log(this.env.showSteps);
    this.cpayment();
    /*this.router.events.subscribe((event) => {
      const ev: any = event;
      if (event instanceof NavigationStart) {
        console.log("eventDestroyed", ev);
      }
      if (ev.restoredState.navigationId !== 2){//if (event instanceof NavigationStart) {
        //this.env.showSteps = false;
      }
    });*/
  }
  cpayment() {
    this.env.isContentLoading = true;
    this.copaymentInfo = [];
    this.typeSelectedProvider = this.provider.data[0].idProvider.code;
    this.env.typeSelectedProvider = this.typeSelectedProvider;
    this.selectedIdProvider = this.provider.data[0].idProvider.idProvider;
    this.env.selectedIdProvider = this.selectedIdProvider;
    console.log(this.provider);
    this.realm.loginAsync();
    this.realm.getCopaymentbyProvider(this.typeSelectedProvider);
    this.apiService.responseGet$.subscribe( data => {
      const qw: any = data;
      console.log(qw);
      this.env.isContentLoading = false;
      if (qw.code === 701) {
        this.copaymentInfo = qw.resultInsuredPartipation.success[0];
        console.log(this.copaymentInfo);
      }
    });
  }

  nextPage() {
    this.router.navigate(['home/payment']);
  }
}
